import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import ScrollToTopWrapper from "app/pages/sales-intelligence/common-components/ScrollToTopWrapper/ScrollToTopWrapper";
import { desktopMedia } from "app/pages/sales-intelligence/modules/manage-integrations/containers/styles";

export const StyledScrollToTopWrapper = styled(ScrollToTopWrapper)`
    display: flex;
`;

export const StyledManagementPageContainer = styled.div`
    flex-grow: 1;
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledManagementPageWrapper = styled(Flex)`
    position: relative;
    width: 100%;
    padding: 40px 0 40px 0;
    margin: 0 auto;

    max-width: 1084px;

    ${desktopMedia`
        max-width: 1366px;
    `}
`;
